export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-scale/src/number.js
// module id = 154
// module chunks = 0